export default {

  setRider(state, val) {

    // console.debug('setting rider');
    // console.debug(state);
    // console.debug(val.riders);

    state.newLife.lifeGeneralInfo.riders = val.riders;
  },

  setLifeSelectionList(state, val) {

    state.lifeSelectionList = val.lifeSelectionList
  },

  setWorkflowCurrentStep(state, val) {
    state.newLife.workflowCurrentStep = val.currentStep
  },

  setPolicyTypeList(state, val) {
    state.newLife.policyTypeList = val.list
  },

  setCurrentStepFieldValue(state, val) {
    state.newLife.fields[val.name] = val.value
  },

  setCurrentStepFieldStatus(state, val) {
    state.newLife.fields[val.name].disabled = val.disabled
    state.newLife.fields[val.name].hide = val.hide
  },

  setLifeProductFields(state, val) {
    state.newLife.policyFields = val.fieldList
  },

  setLifePolicyID(state, val) {
    state.newLife.policyID = val.policyID
  },

  setLifePaymentMethodID(state, val) {
    state.newLife.paymentMethodID = val.paymentMethodID
  },

  setSelections(state, val) {
    state.allSelections = val.allSelections;
  },

  setLifeGeneralInfo(state, val) {
    state.newLife.lifeGeneralInfo = val.lifeGeneralInfo;
  },

  setLifeAttachments(state, val) {
    state.newLife.lifeAttachments = val.lifeAttachments
  },

  setLifeApproveAgent(state, val) {
    state.newLife.lifeGeneralInfo.approveAgent = val.approveAgent
  },

  setIsRejected(state, val) {
    state.newLife.isRejected = val.value
  },

  setIsCompleted(state, val) {
    state.newLife.isCompleted = val.value
  },

  setPolicyAgent(state, val) {
    state.newLife.lifeGeneralInfo.policyAgent = val.policyAgent;
  },

  setName(state, val) {
    state.newLife[val.key].chinese = val.chinese
    state.newLife[val.key].english = val.english
  },

  setPolicyID(state, val) {
    state.newLife.policyID = val.ID;
  },
  disabledButtonStatus(state){
    let obj = state.newLife.fields;
    obj.prevBtn.hide = true;
    obj.nextBtn.hide = true;
    obj.deleteBtn.hide = true;
    obj.inforceBtn.hide = true;
    obj.rejectBtn.hide = true;
    obj.saveBtn.hide = true;
  }

}



// WEBPACK FOOTER //
// ./src/Osm/LifePolicy/store/mutations.js